export const types = {
    // Sync
    FILL_TASKS:         'FILL_TASKS',
    CREATE_TASK:        'CREATE_TASK',
    UPDATE_TASK:        'UPDATE_TASK',
    REMOVE_TASK:        'REMOVE_TASK',
    COMPLETE_ALL_TASKS: 'COMPLETE_ALL_TASKS',

    // Async
    FETCH_TASKS_ASYNC:        'FETCH_TASKS_ASYNC',
    CREATE_TASK_ASYNC:        'CREATE_TASK_ASYNC',
    UPDATE_TASK_ASYNC:        'UPDATE_TASK_ASYNC',
    REMOVE_TASK_ASYNC:        'REMOVE_TASK_ASYNC',
    COMPLETE_ALL_TASKS_ASYNC: 'COMPLETE_ALL_TASKS_ASYNC',
};
